var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Jj-empty"},[_c('img',{staticClass:"err-img",attrs:{"src":_vm.src,"alt":"出错了","width":_vm.width}}),_c('p',{staticClass:"err-msg"},[_vm._v(_vm._s(_vm.msg))])])
}
var staticRenderFns = []

export { render, staticRenderFns }